import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { forkJoin } from 'rxjs';
import { ItemParametro } from 'src/app/shared/models/itemparametro';
import { LogAutorizacion } from 'src/app/shared/models/logAutorizacion';
import { PedidoEspecialPlantaCabecera } from 'src/app/shared/models/pedidoEspecialPlantaCabecera';
import { PedidoEspecialPlantaRetencion } from 'src/app/shared/models/pedidoEspecialPlantaRetencion';
import { AdmService } from 'src/app/shared/services/adm.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { ParametrosService } from 'src/app/shared/services/parametros.service';
import { PEPService } from 'src/app/shared/services/pep.service';
import { isMobile, isMobileXL, loadData } from 'src/app/shared/utils/helpers';
@Component({
  selector: 'app-pepa-aprobacion-retenido-dialog',
  templateUrl: './pepa-aprobacion-retenido-dialog.component.html'
})
export class PEPAAprobacionRetenidoDialogComponent {

  displayedColumns = ['aprobado', 'tipoRetencion', 'mensajeRetencion'];
  //displayedColumns = ['tipoRetencion', 'mensajeRetencion', 'fechaAprobacion', 'aprobador', 'comentario'];
  dataSource = new MatTableDataSource<PedidoEspecialPlantaRetencion>();
  @ViewChild('matSort') matSort: MatSort;
  @ViewChild('matPaginator') matPaginator: MatPaginator;

  pepaCab: PedidoEspecialPlantaCabecera;
  motivosRetencion: ItemParametro[] = []
  motivoRetencionSeleccionado: ItemParametro;
  form: FormGroup;

  motivosSeleccionados: Set<PedidoEspecialPlantaRetencion> = new Set<PedidoEspecialPlantaRetencion>();

  constructor(
    private pepService: PEPService,
    private configService: ConfigService,
    private loggedService: LoggedService,
    private fb: FormBuilder,
    private admService: AdmService,
    private parametrosService: ParametrosService,
    private dialogRef: MatDialogRef<PEPAAprobacionRetenidoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {

    if (data.cab != null) {
      this.pepaCab = data.cab;
    }

    this.form = this.fb.group({
      comentarioLogAutorizacion: [''],
      idMotivoRetencion: [''],
      codigosRetencionesAprobadas: [[]],
      motivoRetencion: ['']

    })
  }

  public Etiquetas: {

    NombreApellidoAprobadorRetencion: string,
    RetencionAprobada: string,
    TipoRetencion: string,
    MensajeRetencion: string,
    FechaAprobacionRetencion: string,
    Comentario: string,
    SinRegistros: string
    MotivoRetencion: string
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.matPaginator;
    this.dataSource.sort = this.matSort;
    this.dataSource.sort.disableClear = true;
  }
  ngOnInit() {

    this.Etiquetas = {
      NombreApellidoAprobadorRetencion: this.configService.etiquetas.NombreApellidoAprobadorRetencion,
      RetencionAprobada: this.configService.etiquetas.RetencionAprobada,
      TipoRetencion: this.configService.etiquetas.TipoRetencion,
      MensajeRetencion: this.configService.etiquetas.MensajeRetencion,
      FechaAprobacionRetencion: this.configService.etiquetas.FechaAprobacionRetencion,
      Comentario: this.configService.etiquetas.Comentario,
      SinRegistros: this.configService.etiquetas.SinRegistros,
      MotivoRetencion: this.configService.etiquetas.MotivoRetencion
    }
    this.loadRetenciones();

  }


  loadRetenciones() {
    if (this.pepaCab) {
      this.pepService.cPedidoEspecialPlantaRetenciones(this.pepaCab.idPais, this.pepaCab.idCompania, this.pepaCab.idSalesOrg, this.pepaCab.nroPedido)
        .subscribe((retenciones: PedidoEspecialPlantaRetencion[]) => {
          this.dataSource.data = retenciones.filter(retencion => !retencion.aprobado);
        });
    }
  }

  toggleSeleccionMotivo(retencion: PedidoEspecialPlantaRetencion) {
    if (this.motivosSeleccionados.has(retencion)) {
      this.motivosSeleccionados.delete(retencion);
    } else {
      this.motivosSeleccionados.add(retencion);
    }
  }

  aceptar() {
    let codigosAprobados: string[] = [];
    if (this.motivosSeleccionados.size > 0) {
       codigosAprobados = Array.from(this.motivosSeleccionados).map(motivo => {
        motivo.aprobado = true;
        return motivo.idTipoRetencion;
      });
    }

    this.form.controls['codigosRetencionesAprobadas'].setValue(codigosAprobados.length ? codigosAprobados : []);
    this.dialogRef.close(this.form.value);
  }

  hayAprobado(): boolean {
    return this.motivosSeleccionados.size > 0;
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }

}
